import { render, staticRenderFns } from "./catalog-list-used-desktop.vue?vue&type=template&id=e7136856&"
import script from "./catalog-list-used-desktop.vue?vue&type=script&lang=js&"
export * from "./catalog-list-used-desktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Pagination: require('/var/www/components/pagination/pagination.vue').default})
